import styled from 'styled-components';
import { Handle as CustomHandle, HandleProps } from 'reactflow';
import { Box, Typography } from '@mui/material';
import { ISecondaryNodeContainer, SecondaryNodeColor } from 'types';
import { handleNodeColor, handleNodeBgColor } from 'utils';

export const Container = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(2, 2.25)};
  border-radius: 14px;
  background-color: ${({ color, selected }: ISecondaryNodeContainer) =>
    !selected ? handleNodeColor(color) : handleNodeBgColor(color)};
  border: 2px solid ${({ color }: ISecondaryNodeContainer) => handleNodeColor(color)};
  border-style: ${({ borderStyle }: ISecondaryNodeContainer) => borderStyle || 'solid'};
  color: ${({ color, selected }: ISecondaryNodeContainer) =>
    !selected ? 'white' : handleNodeColor(color)};
  min-width: 210px;
  position: relative;
  cursor: ${({ selected }: ISecondaryNodeContainer) => (selected ? 'grab' : 'pointer')};

  box-shadow: ${({ color, selected }: ISecondaryNodeContainer) =>
    selected ? `0px 0px 28px ${handleNodeColor(color)}` : 'none'};

  transition: box-shadow 150ms ease-in-out;

  &:hover {
    box-shadow: ${({ color }: ISecondaryNodeContainer) => `0px 0px 28px ${handleNodeColor(color)}`};
  }
`;

export const Label = styled(Typography)`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold} !important;
  text-transform: capitalize;
`;

interface IHandle extends HandleProps {
  color: SecondaryNodeColor;
  type: 'target' | 'source';
}

export const Handle = styled(CustomHandle)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;

  svg {
    width: 24px;
    height: 24px;
    fill: ${({ color }: IHandle) => handleNodeColor(color)};
  }
  transform: ${({ type }: IHandle) =>
    type === 'source' ? 'translateX(5px) translateY(-5px)' : 'translateX(-5px) translateY(-2px)'};
`;

export const SummaryCountContainer = styled(Box)`
  display: flex;
  column-gap: 10px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-50%, 150%);
`;

export const SummaryCount = styled(Box)`
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 29px;
  min-width: 29px;
  color: ${({ theme }) => theme.palette.common.white};
  font-weight: 700;
  font-size: 12px;
  border: 2px solid ${({ theme }) => theme.palette.common.white};

  &:nth-child(3n + 1) {
    background-color: ${({ theme }) => theme.palette.warning.light};
  }
  &:nth-child(3n + 2) {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
  &:nth-child(3n + 3) {
    background-color: ${({ theme }) => theme.palette.success.main};
  }
`;
